"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAllPrintQuantities = exports.setOpeningPrintQuantities = exports.setOpeningPrintQuantity = exports.SET_ALL_PRINT_QUANTITIES = exports.SET_OPENING_PRINT_QUANTITIES = void 0;
const immer_1 = require("immer");
const core_1 = require("@mapmaker/core");
exports.SET_OPENING_PRINT_QUANTITIES = "print_quantity.set_opening_print_quantities";
exports.SET_ALL_PRINT_QUANTITIES = "print_quantity.set_all_print_quantities";
function setOpeningPrintQuantity(openingId, quantity) {
    return {
        type: exports.SET_OPENING_PRINT_QUANTITIES,
        openingIds: [openingId],
        quantity,
    };
}
exports.setOpeningPrintQuantity = setOpeningPrintQuantity;
function setOpeningPrintQuantities(openingIds, quantity, setOthersToZero = false) {
    return {
        type: exports.SET_OPENING_PRINT_QUANTITIES,
        openingIds,
        quantity,
        setOthersToZero,
    };
}
exports.setOpeningPrintQuantities = setOpeningPrintQuantities;
function setAllPrintQuantities(quantity) {
    return {
        type: exports.SET_ALL_PRINT_QUANTITIES,
        quantity,
    };
}
exports.setAllPrintQuantities = setAllPrintQuantities;
function getInitialState(file) {
    const openings = (0, core_1.getInputs)(file, "OPENING");
    return Object.entries(openings).reduce((quantities, [openingId, openingInput]) => {
        var _a;
        if (((_a = openingInput === null || openingInput === void 0 ? void 0 : openingInput.enabled) !== null && _a !== void 0 ? _a : openings[openingId].enabled) === false) {
            return quantities;
        }
        // Maybe fancier logic in the future for "already printed" photos?
        if (openingInput.images.length > 0) {
            quantities[openingId] = 1;
        }
        return quantities;
    }, {});
}
function createPrintQuantitiesReducer(file) {
    return (0, immer_1.produce)((draft, action) => {
        if (draft === undefined) {
            return getInitialState(file);
        }
        switch (action.type) {
            case exports.SET_ALL_PRINT_QUANTITIES:
                Object.keys(draft).forEach(openingId => {
                    draft[openingId] = action.quantity;
                });
                break;
            case exports.SET_OPENING_PRINT_QUANTITIES:
                if (action.setOthersToZero) {
                    Object.keys(draft).forEach(openingId => {
                        draft[openingId] = 0;
                    });
                }
                action.openingIds.forEach(openingId => {
                    draft[openingId] = Math.min(Math.max(action.quantity, 0), 999);
                });
                break;
            default:
                break;
        }
    });
}
exports.default = createPrintQuantitiesReducer;
//# sourceMappingURL=data:application/json;base64,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